import React from 'react';
import { useIntl } from 'react-intl';

import Icon from '../../../Icon';

import styles from './index.styl';

const AppointmentError = () => {
  const { formatMessage } = useIntl();

  const errorMessage = formatMessage({ id: 'errors.securityLink' });

  return (
    <section className={styles.section}>
      <div className={styles.content}>
        <Icon icon="error" name="error" size={48} />
        <div className={styles.message}>{errorMessage}</div>
      </div>
    </section>
  );
};

export default AppointmentError;



// WEBPACK FOOTER //
// ./src/components/Paperwork/components/AppointmentError/index.js